import api from './api';

export const getAllModifiers = async (storeId) => {
  const response = await api.get('/modifiers', { params: { storeId } });
  return response.data;
};

export const importModifiers = async (file, storeId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('storeId', storeId);
  const response = await api.post('/modifiers/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteModifier = async (id) => {
  const response = await api.delete(`/modifiers/${id}`);
  return response.data;
};

export const clearStoreModifiers = async (storeId) => {
  const response = await api.delete(`/modifiers/store/${storeId}`);
  return response.data;
};